import React, { Component, PropTypes } from 'react'
import RaisedButton from 'material-ui/RaisedButton';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';
import ActionLaunch from 'material-ui/svg-icons/action/launch';

export default class LaunchPipeline extends Component {
  render() {
    const { onLaunchClick } = this.props

    return (
			<div>
			  <Paper zDepth={2}>
        <h2>Launch Pipeline</h2>
					<Divider />
          <RaisedButton
            onClick={onLaunchClick}
						icon={<ActionLaunch/>}>
						Launch 
					</RaisedButton>
      </Paper>
		</div>
    )
  }
}

LaunchPipeline.propTypes = {
  onLaunchClick: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/LaunchPipeline.jsx